import { render } from "./SiteMainList.vue?vue&type=template&id=5206031a"
import script from "./SiteMainList.vue?vue&type=script&lang=js"
export * from "./SiteMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__